import LAYOUT_CONST from 'constant';
import logoSecure from 'assets/images/logo-secure.svg';

export const defaultConfig = {
    layout: LAYOUT_CONST.VERTICAL_LAYOUT,
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER,
    fontFamily: 'Montserrat, sans-serif',
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light',
    presetColor: 'default',
    locale: 'es-ES',
    rtlLayout: false,
    container: false,
    defaultLogo: logoSecure,
    primaryColor: '#3949F9',
    secondaryColor: '#f3f4ff'
};

export default defaultConfig;
